import React, { useState, useEffect } from "react";
import {
    Box,
    Card,
    CardContent,
} from '@mui/material';
import DataListRowItem from './dataListRowItem';

const DataCard = (props) => {
    const { classes, item, index } = props;
    const [redirectToDetails, setRedirectToDetails] = useState(false);

    useEffect(() => {
        if (props.item && props.item.row && props.item.row.some(i => i.titleRedirect)) {
            setRedirectToDetails(true);
        }

    }, [props.item])

    return (
        <Card
            classes={{ root: classes.paperContent }}
            sx={{ width: '100%' }}>
            <CardContent sx={{ p: 2 }} className={classes.cardContent} style={{ cursor: redirectToDetails ? 'pointer' : 'auto' }}
                onClick={(event) => {
                    if (redirectToDetails) {
                        props.handleViewNotes(item, event)
                    }
                }}>
                <Box className={classes.rowContent}>
                    <>
                        {item.row.map((row, rowIndex) => (
                            <DataListRowItem
                                key={`datarowitem_${rowIndex}`}
                                row={row}
                                item={item}
                                index={index}
                                {...props}
                            />
                        ))}
                    </>
                </Box>
            </CardContent>
        </Card>
    )
}

export default DataCard;